import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 animate-fade-in">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            蘑菇成品人视频分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按主题浏览蘑菇成品人视频教程，快速找到你需要的蘑菇种植视频资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {displayCategories.map((cat, idx) => (
            <div
              key={cat.slug}
              className="animate-fade-in-up"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <Link to={`/category/${cat.slug}`}>
                <CategoryCard {...cat} />
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
          >
            查看全部视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}